export default {
    name: ["", ""],
    logout: ["Log Out", "ចាកចេញ"],
    headTitle: ["MISTI Digital Identity System", "ប្រព័ន្ធគ្រប់គ្រងអត្តសញ្ញាណឌីជីថលតែមួយ"],
    system: ["Ministry of Industry, Science, Technology & Innovation", "ក្រសួងឧស្សាហកម្ម វិទ្យាសាស្រ្ត បច្ចេកវិទ្យា និងនវានុវត្តន៍"],
    welcome: ["Welcome !", "សូមស្វាគមន៍"],
    chooseMethod: ["Please choose a method to log into digital system.", "សូមធ្វើការជ្រើសរើសវិធីណាមួយដើម្បីចូលទៅកាន់ប្រព័ន្ធឌីជីថល"],
    loginCamdigikey: ["Sign in with CamDigiKey", "ចូលប្រព័ន្ធដោយប្រើប្រាស់ CamDigiKey"],
    loginPassword: ["Sign in with Password", "ចូលប្រព័ន្ធដោយប្រើប្រាស់ពាក្យសម្ងាត់"],
    loginCamdigikeyText: ["Sign into system using CamDigiKey Mobile Application.", "ចូលប្រព័ន្ធដោយប្រើប្រាស់កម្មវិធីទូរស័ព្ទ​ដៃ CamDigiKey"],
    loginPasswordText: ["Sign into system using ID, Gov ID, Phone Number or Email and Password.", "ចូលប្រព័ន្ធដោយប្រើអត្តសញ្ញាណប័ណ្ណ ប័ណ្ណមន្រ្តីរាជការ លេខទូរស័ព្ទ ឬអ៊ីម៉ែល និងពាក្យសម្ងាត់។"],
    passwordPlease: ["Please fill in National ID, Government Official ID, Phone Number or Email and Password.", "សូមបំពេញលេខអត្តសញ្ញាណប័ណ្ណ លេខប័ណ្ណមន្រ្តីរាជការ លេខទូរស័ព្ទ ឬអ៊ីម៉ែល និងពាក្យសម្ងាត់ដើម្បីចូលប្រព័ន្ធ"],
    camdigikeyPlease: ["Please scan the QR Code below to sign in.", "សូមស្កេន QR Code ខាងក្រោមដើម្បីចូលប្រព័ន្ធ"],
    loginUser: ["Account", "ឈ្មោះគណនី"],
    password: ["Password", "ពាក្យសម្ងាត់"],
    cancel: ["Cancel", "បោះបង់"],

    login: ["Sign In", "ចូលប្រព័ន្ធ"],
    goHome: ["Go Back Home", "ទៅកាន់ទំព័រដើម"],
    loginExpired: ["Your session is expired.", "ការចូលប្រព័ន្ធត្រូវបានផុតកំណត់ !"],
    pleaseLoginAgain: ["Please request your session again.", "សូមធ្វើការស្នើសុំចូលប្រព័ន្ធម្តងទៀត។"],
    camdigi1: ["1. Download CamDigiKey app: ", "១. ទាញយកកម្មវិធី CamDigiKey៖ "],
    camdigi2: ["2. Scan QR code on your CamDigiKey App.", "២. ស្កែន QR Code ក្នុងកម្មវិធី CamDigiKey របស់លោកអ្នក។"],
    camdigi3: ["3. Insert your 6-digit pin in the application.", "៣. បញ្ចូលលេខកូដ 6 ខ្ទង់ទៅក្នុងកម្មវិធីនោះ។"],
    camdigi4: ["4. You will be automatically redirected to the portal.", "៤. អ្នកនឹងត្រូវបានអនុញ្ញាតឱ្យចូលក្នុង Portal ដោយស្វ័យប្រវត្តិ។"],
    instruction: ["Instruction:", "ការណែនាំ៖"],
    change_password: ["Change Password", "ផ្លាស់ប្តូរពាក្យសម្ងាត់"],
    changePasswordPlease: ["Please fill in National ID, Government Official ID, Phone Number or Email and Old Password.", "សូមបំពេញលេខអត្តសញ្ញាណប័ណ្ណ លេខប័ណ្ណមន្រ្តីរាជការ លេខទូរស័ព្ទ ឬអ៊ីម៉ែល និងពាក្យសម្ងាត់ចាស់ដើម្បីផ្លាស់ប្តូរពាក្យសម្ងាត់។"],
    new_password: ["New Password", "ពាក្យសម្ងាត់ថ្មី"],
    confirm_password: ["Confirm New Password", "បញ្ជាក់ពាក្យសម្ងាត់ថ្មី"],
    change_new_password: ["Set New Password", "កំណត់ពាក្យសម្ងាត់ថ្មី"],
    change_new_password_please: ["Please fill in new password and confirm new password to change.", "សូមធ្វើការបំពេញពាក្យសម្ងាត់ថ្មី និងបញ្ជាក់ពាក្យសម្ងាត់ថ្មីដើម្បីផ្លាស់ប្តូរ។"],
    change_password_button: ["Change Password", "ផ្លាស់ប្តូរថ្មី"],
    new_password_success: ["You have changed your password successfully.", "អ្នកបានធ្វើការផ្លាស់ប្តូរពាក្យសម្ងាត់ដោយជោគជ័យ។"],
    redirect: ["Redirecting...", "ទៅកាន់ទំព័រដើម..."],
    test: ["Profile", "ព័ត៌មានអំពីទំព័រ"],
    test: ["Profile", "ព័ត៌មានអំពីទំព័រ"],
}


// WEBPACK FOOTER //
// ./src/config/locale.js